










import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * provides common box-shadow styling to wrapped component
 *
 * N.B.: The parent container will need to provide at least 5px
 * of padding to prevent the box-shadow from being clipped.
 */
@Component
export default class ShadowBox extends Vue {
	@Prop({default: false})
	isSelected!: boolean;
}
